import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import it from './locales/it.json';
import en from './locales/en.json';

/**
 * Language is derived from the URL (/en/... vs unprefixed), not from the
 * browser or a stored preference — see App.tsx's `basename` handling. This
 * is what lets Google index the Italian and English pages as distinct,
 * stable URLs instead of the same URL silently changing language.
 */
const initialLng =
  typeof window !== 'undefined' &&
  (window.location.pathname === '/en' || window.location.pathname.startsWith('/en/'))
    ? 'en'
    : 'it';

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  lng: initialLng,
  fallbackLng: 'it',
  supportedLngs: ['it', 'en'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
